import React from "react";
import { w2pt, izoom } from "../../utils/coords";
import { Geo } from "../../utils/geo";
import { formatDistanceAuto } from "../../utils/units";

export default function DimensionLabels({ st, zoom, onEditDim, unitPreset }) {
  const s = izoom(zoom);
  const dimLayer = (st.layers || {}).dimensions;
  if (dimLayer?.visible === false) return null;

  return (
    <g>
      {Object.values(st.edges).map(e => {
        const ab = st.halfEdges[e.halfEdgeA], ba = st.halfEdges[e.halfEdgeB];
        if (!ab || !ba) return null;
        const nA = st.nodes[ab.originId], nB = st.nodes[ba.originId];
        if (!nA || !nB) return null;

        const pA = w2pt(nA), pB = w2pt(nB);
        const dx = pB.x - pA.x, dy = pB.y - pA.y, L = Math.sqrt(dx * dx + dy * dy);
        if (L < s * 60) return null;

        const mx = (pA.x + pB.x) / 2, my = (pA.y + pB.y) / 2;
        let ang = Math.atan2(dy, dx) * 180 / Math.PI;
        if (ang > 90 || ang < -90) ang += 180;

        const nx = -dy / L, ny = dx / L, off = s * 18;
        const lx = mx + nx * off, ly = my + ny * off;
        const lenMm = Math.round(Geo.d(nA, nB));
        const displayText = formatDistanceAuto(lenMm, unitPreset);

        return (
          <g key={`dim-${e.id}`} style={{ cursor: "text" }}
            onClick={ev => { ev.stopPropagation(); onEditDim(e.id, lenMm, { x: lx, y: ly }); }}>
            <rect x={lx - s * 18} y={ly - s * 6} width={s * 36} height={s * 11} rx={s}
              fill="#030810" stroke="#1a2636" strokeWidth={s * 0.4}
              transform={`rotate(${ang},${lx},${ly})`} />
            <text x={lx} y={ly + s * 3.5} textAnchor="middle" fontSize={s * 7.5}
              fill="#60a5fa" fontFamily="'JetBrains Mono',monospace" fontWeight={700}
              style={{ pointerEvents: "none" }} transform={`rotate(${ang},${lx},${ly})`}>
              {displayText}
            </text>
          </g>
        );
      })}
    </g>
  );
}
